import { render } from "./SensorDetails.vue?vue&type=template&id=cb5997fa&scoped=true"
import script from "./SensorDetails.vue?vue&type=script&lang=js"
export * from "./SensorDetails.vue?vue&type=script&lang=js"

import "./SensorDetails.vue?vue&type=style&index=0&id=cb5997fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5997fa"]])

export default __exports__